/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { ReactElement } from 'react';
import { SkillCompletion } from '../containers/skill-completion';
import { PageContent } from './page-content';
import { SkillCompletionData, PageType, PageDataParams } from 'its-pages';

export class SkillCompletionContent extends PageContent {
  public get component(): ReactElement {
    return (
      <SkillCompletion skillCompletionContent={this} key={this.pageData.seed} />
    );
  }

  public get pageType(): PageType {
    return PageType.Banner;
  }

  public constructor(params: PageDataParams) {
    super(new SkillCompletionData(params));
  }
}
